const parseAppKey = () => {
	let parts = window.location.pathname.split("/");
	if (parts[1] === "apps") {
		return parts[2];
	} else {
		return undefined;
	}
};

export default parseAppKey;
